<div style="display: flex; justify-content: space-between; padding-bottom: 5px;">
    <div class="filter-container">
        <mat-form-field appearance="outline">
            <mat-label>Filter by budget nr.</mat-label>
            <input matInput [formControl]="budgetNrFilterControl"/>
        </mat-form-field>

        <mat-form-field appearance="outline" style="min-width: 200px;">
            <mat-label>Filter by sales manager</mat-label>
            <input matInput [formControl]="salesManagerFilterControl"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Filter by company name</mat-label>
            <input matInput [formControl]="companyNameFilterControl"/>
        </mat-form-field>

        <mat-form-field appearance="outline" style="min-width: 200px;">
            <mat-label>Filter by opportunity name</mat-label>
            <input matInput [formControl]="opportunityNameFilterControl"/>
        </mat-form-field>

        @if (hasAddOpportunityRole) {
            <button mat-flat-button color="primary" (click)="openOpportunityFormDialog()">Create new opportunity
            </button>
        }
    </div>

    <mat-card appearance="outlined">
        <!-- Wrap the title in a header block so Material applies the correct top and side paddings -->
        <mat-card-header style="padding-bottom: 8px;">
            <mat-card-title style="font-size: 1rem; font-weight: 600;">Forecast amount</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div style="display: flex; flex-direction: column; gap: 5px">
                <div style="display: flex; justify-content: space-between; gap: 15px">
                    <span style="font-weight: 400">Total ITA: </span>
                    <span>{{ totalAmountITA ?? 0 | currency: 'EUR' }}</span>
                </div>
                <div style="display: flex; justify-content: space-between; gap: 15px">
                    <span style="font-weight: 400">Total USA: </span>
                    <span>{{ totalAmountUSA ?? 0 | currency: 'EUR' }}</span>
                </div>
                <div style="display: flex; justify-content: space-between; gap: 15px">
                    <span style="font-weight: 400">Total ITA + USA: </span>
                    <span>{{ (totalAmountITA ?? 0) + (totalAmountUSA ?? 0) | currency: 'EUR' }}</span>
                </div>
                @if (linkDashboardOpportunities && hasAddOpportunityRole) {
                    <div style="display: flex; justify-content: center; gap: 5px; align-items: center; margin-top: 8px;">
                        <a target="_blank" href="{{linkDashboardOpportunities}}">
                            Go to sales dashboard
                        </a>
                        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">open_in_new</mat-icon>
                    </div>
                }
            </div>
        </mat-card-content>
    </mat-card>

</div>

@if (isLoading || (pendingAction$ | async)) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-table [dataSource]="datasource" matSort matSortActive="followUpDate" matSortDirection="desc" matSortDisableClear>

    <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef i18n>
            Status
            <ng-container>
                <button mat-icon-button #statusMenuTrigger="matMenuTrigger"
                        [matMenuTriggerFor]="statusFilterMenu" (click)="statusSelectFilter.open()">
                    <mat-icon style="font-size: 18px">filter_list</mat-icon>
                </button>
                <mat-menu #statusFilterMenu yPosition='below' xPosition="after">
                    <mat-select multiple #statusSelectFilter (openedChange)="statusMenuTrigger.closeMenu()"
                                (selectionChange)="statusSelectionChange($event)" panelClass="wb-mat-select-panel">
                        @for (s of OpportunityStatuses | keyvalue; track s) {
                            <mat-option [value]="s.value">{{ s.value }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-menu>
            </ng-container>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
            <div class="opportunity-status-label" [ngClass]="{
                            'color-green': row.status === 'Won',
                            'color-yellow': row.status !== 'Lost' && row.status !== 'Won',
                            'color-red': row.status === 'Lost'
            }">
                {{ row.status }}
            </div>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="opportunityStage">
        <mat-header-cell *matHeaderCellDef i18n>
            Stage
            <ng-container>
                <button mat-icon-button #stageMenuTrigger="matMenuTrigger"
                        [matMenuTriggerFor]="stageFilterMenu" (click)="stageSelectFilter.open()">
                    <mat-icon style="font-size: 18px">filter_list</mat-icon>
                </button>
                <mat-menu #stageFilterMenu yPosition='below' xPosition="after">
                    <mat-select multiple #stageSelectFilter [value]="storedStageSelection"
                                (openedChange)="stageMenuTrigger.closeMenu()"
                                (selectionChange)="stageSelectionChange($event)" panelClass="wb-mat-select-panel">
                        @for (s of OpportunityStages | keyvalue; track s) {
                            <mat-option [value]="s.value">
                                {{ s.value }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-menu>
            </ng-container>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
            {{ row.opportunityStage }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="salesManager">
        <mat-header-cell *matHeaderCellDef i18n>Sales manager</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.salesManager }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="budgetNr">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Budget Nr.</mat-header-cell>
        <mat-cell class="column" *matCellDef="let row">
            <span class="link" (click)="navigateToBudget(row)">{{ row.budgetNr }}</span>
            @if (row.mergedBudgetId) {
                <span class="side-note">(merged)</span>
            }
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="companyName">
        <mat-header-cell *matHeaderCellDef i18n>Company name</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.companyName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="opportunityName">
        <mat-header-cell *matHeaderCellDef i18n>Opportunity name</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.opportunityName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="nextSteps">
        <mat-header-cell *matHeaderCellDef i18n>Next steps</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.nextSteps }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="potentialClosure">
        <mat-header-cell *matHeaderCellDef i18n>Potential closure</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.potentialClosureQuarter }} - {{ row.potentialClosureYear }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="proposalSentOn">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Proposal sent on</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.proposalSentOn | timestamp | date }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="proposalRequested">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Proposal requested</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.proposalRequested | timestamp | date }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="nextFollowUpDate">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Next follow-up</mat-header-cell>
        <mat-cell *matCellDef="let row">
      <span [ngStyle]="{'color': isNextFollowUpDateExpired(row)}">
        {{ row.nextFollowUpDate | timestamp | date }}
      </span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="followUpDate">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Last follow-up</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.followUpDate | timestamp | date }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="forecastAmount">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Forecast amount</mat-header-cell>
        <mat-cell *matCellDef="let row">
            @if (row.currency === 'USD') {
                <mat-icon style="margin-left: 2px; margin-top: 7px; font-size: 16px"
                          [matTooltip]="(row.forecastAmountITA) | currency: 'EUR'">
                    currency_exchange
                </mat-icon>
            }
            {{ row.currency === 'USD' ? (row.forecastAmountUSA | currency: 'USD') : (row.forecastAmountITA | currency: 'EUR') }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef i18n></mat-header-cell>
        <mat-cell *matCellDef="let row">
            <div style="display: flex; justify-content: flex-end">
                <button mat-icon-button [routerLink]="[row.id]">
                    <mat-icon>visibility</mat-icon>
                </button>

                @if (row.status === OpportunityStatuses.IN_PROGRESS) {
                    <button mat-icon-button [matMenuTriggerFor]="opportunityMenu"
                    >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                }
                <mat-menu #opportunityMenu="matMenu">
                    <app-opportunity-contextual-menu [opportunity]="row"></app-opportunity-contextual-menu>
                </mat-menu>
            </div>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"
    ></mat-row>
</mat-table>
<mat-paginator [pageSizeOptions]="[5, 10, 25, 100, 500]" [pageSize]="preferredPageSize"></mat-paginator>